export enum ItemtypeEnum {
    SEWING_TRIM = 'SEWING TRIM',
    PACKING_TRIM = 'PACKING TRIM',
    FABRIC='FABRIC'
  }